import {useState, useEffect} from 'react';

// evento listener para controlar o tamanho da tela

const useWindowWidth = () => {
  const [ windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize)
  }, []);

    return windowWidth;
}

export default useWindowWidth;